var _g, _path, _g2, _path2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWarranty(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 66,
    viewBox: "0 0 42 66",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_dd_1683_5563)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31 2H11.5C7.02166 2 4.78249 2 3.39124 3.39124C2 4.78249 2 7.02166 2 11.5V48.3523C2 55.2196 2 58.6532 3.85721 60.0792C4.35861 60.4642 4.93181 60.7452 5.54322 60.9058C7.80791 61.5007 10.5223 59.3979 15.9512 55.1923C18.2393 53.4198 19.3833 52.5335 20.6926 52.3788C21.0629 52.335 21.4371 52.335 21.8074 52.3788C23.1167 52.5335 24.2608 53.4198 26.5488 55.1923C31.9777 59.3979 34.6921 61.5007 36.9568 60.9058C37.5682 60.7452 38.1414 60.4642 38.6428 60.0792C40.5 58.6532 40.5 55.2196 40.5 48.3523V11.5C40.5 7.02166 40.5 4.78249 39.1088 3.39124C37.7175 2 35.4783 2 31 2Z",
    fill: "white"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29 6.25H14V59.75L21.5 54.2155L29 59.75V6.25Z",
    fill: "#FAC900"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_dd_1683_5563)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32 4H10.5C7.43587 4 5.90381 4 4.9519 4.9519C4 5.90381 4 7.43587 4 10.5V47.3625C4 53.087 4 55.9493 5.80876 56.8442C7.61752 57.7391 9.89285 56.0026 14.4435 52.5296L17.3065 50.3446C19.2032 48.8971 20.1515 48.1733 21.25 48.1733C22.3485 48.1733 23.2968 48.8971 25.1935 50.3446L28.0565 52.5296L28.0565 52.5296C32.6072 56.0026 34.8825 57.7391 36.6912 56.8442C38.5 55.9493 38.5 53.087 38.5 47.3625V10.5C38.5 7.43587 38.5 5.90381 37.5481 4.9519C36.5962 4 35.0641 4 32 4Z",
    fill: "white"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21 17.75L23.8078 22.3853L29.084 23.6234L25.5432 27.7262L25.9962 33.1266L21 31.027L16.0038 33.1266L16.4568 27.7262L12.916 23.6234L18.1922 22.3853L21 17.75Z",
    fill: "#FAC900"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_dd_1683_5563",
    x: 0.875,
    y: 0.875,
    width: 40.75,
    height: 62.0059,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.75
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5625
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.168 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1683_5563"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5625
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.084 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_1683_5563",
    result: "effect2_dropShadow_1683_5563"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_1683_5563",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_dd_1683_5563",
    x: 2.875,
    y: 2.875,
    width: 36.75,
    height: 56.0762,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.75
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5625
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.168 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1683_5563"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5625
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.084 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_1683_5563",
    result: "effect2_dropShadow_1683_5563"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_1683_5563",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarranty);
export default __webpack_public_path__ + "static/media/warranty.c15a0fe702cb76a08f70d75cd4aa286e.svg";
export { ForwardRef as ReactComponent };